import React, { useState } from "react";
import TypeIcon from "../../svgs/type.svg";
import FileUpload from "./FileUpload";
import FormField from "../../../Shared/Form/FormField";

const UploadModal = ({
  showUploadModal,
  setShowUploadModal,
  inventoryTypeForm,
  setInventoryTypeForm,
  uploadedFile,
  handleFileUpload,
  handleDownloadSample,
  handleUploadSubmit,
  isUploading,
  title = "Update stock receive status in bulk",
  modalClassName = "inventory-modal",
  setUploadedFile,
}) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const inventoryTypeOptions = [
    {
      value: "",
      label: "Inventory type Device/Sim/Other...",
      isPlaceholder: true,
    },
    { value: "device", label: "Device" },
    { value: "sim", label: "Sim" },
    { value: "other", label: "Other" },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "inventoryType") {
      setInventoryTypeForm(value);
    }
  };

  const handleSampleDownload = async () => {
    setIsDownloading(true);
    try {
      await handleDownloadSample();
    } catch (error) {
      console.error("Error downloading sample:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  if (!showUploadModal) return null;

  return (
    <div
      className="inventory-modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget && !isUploading && !isDownloading) {
          setShowUploadModal(false);
        }
      }}
    >
      <div
        className={modalClassName}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="inventory-modal-header">
          <h3>{title}</h3>
          <button
            className="close-btn"
            type="button"
            onClick={() =>
              !isUploading && !isDownloading && setShowUploadModal(false)
            }
            disabled={isUploading || isDownloading}
          >
            ×
          </button>
        </div>

        <div className="inventory-modal-body">
          <FormField
            id="inventoryType"
            name="inventoryType"
            title="Inventory Type"
            type="select"
            options={inventoryTypeOptions}
            icon={TypeIcon}
            value={inventoryTypeForm}
            onChange={handleInputChange}
            isFlat
            disabled={isUploading}
            required
          />

          <FileUpload
            handleFileUpload={handleFileUpload}
            handleFileChange={setInventoryTypeForm}
            handleDownloadSample={handleSampleDownload}
            isUploading={isUploading}
            isDownloading={isDownloading}
            isDisabled={isUploading || isDownloading}
            uploadedFile={uploadedFile}
            setUploadedFile={setUploadedFile}
          />
        </div>

        <div className="inventory-modal-footer">
          <button
            className="cancel-btn"
            type="button"
            onClick={() =>
              !isUploading && !isDownloading && setShowUploadModal(false)
            }
            disabled={isUploading || isDownloading}
          >
            Cancel
          </button>
          <button
            className="submit-btn"
            type="button"
            onClick={handleUploadSubmit}
            disabled={
              isUploading ||
              isDownloading ||
              !inventoryTypeForm ||
              !uploadedFile
            }
          >
            {isUploading ? "Uploading..." : "Upload"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadModal;
